import React from 'react';
import { map } from 'lodash';
import classNames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { flyout as Flyout } from 'ui/views/widgets/flyout';
 *
 * // render
 * <Flyout propName='propValue'/>
 */
export const flyout = ( { isOpen, widgets, onCloseClick } ) => {

    const flyoutClassName = classNames( 'ui-flyout', {
        'ui-flyout--open': isOpen
    } );

    return (
        <div className={ flyoutClassName }>
            <div className='ui-flyout__head'>
                <div className='ui-flyout__head__title'>
                    Update Available for Widgets
                </div>
                <div className='ui-flyout__head__close' onClick={ onCloseClick }>
                    <Icon name='close' width='10' height='10' fill='#2d2d2d' />
                </div>
            </div>
            <div className='ui-flyout__body'>
                <div className='ui-flyout__body__widgets'>
                    {
                        map( widgets, widget => {
                            const widgetId = widget.id;
                            const widgetName = widget.name;
                            const widgetClassName = classNames( 'ui-flyout__body__widgets__widget', {
                                'ui-flyout__body__widgets__widget--updated': widget.updated
                            } );

                            return (
                                <div key={ widgetId } className={ widgetClassName }>
                                    <div className='ui-flyout__body__widgets__widget__id'>{ widgetId }</div>
                                    <div className='ui-flyout__body__widgets__widget__name'>{ widgetName }</div>
                                    <div className='ui-flyout__body__widgets__widget__status'>{ widget.type }</div>
                                </div>
                            );
                        } )
                    }
                </div>
                <div className='ui-flyout__body__legend'>
                    <span className='ui-flyout__body__legend__not-updated'>Not Updated</span>
                    <span className='ui-flyout__body__legend__updated'>Updated</span>
                </div>
            </div>
        </div>
    );
};

// set display name
flyout.displayName = 'flyout';

// set default props
flyout.defaultProps = {};

// prop types
flyout.propTypes = {};
